import styled from "styled-components";

export const ImageWrapper = styled.img`
  width: 100%;
  height: 100%;
  width: 50px;
  height: 50px;
  border-radius: 8px;
  margin: auto;
  object-fit: cover;
`;
